import { render, staticRenderFns } from "./VImage.vue?vue&type=template&id=b60bee0c&scoped=true&"
import script from "./VImage.vue?vue&type=script&lang=ts&"
export * from "./VImage.vue?vue&type=script&lang=ts&"
import style0 from "./VImage.vue?vue&type=style&index=0&id=b60bee0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b60bee0c",
  null
  
)

export default component.exports